import { SG_APP_STORE_APP_URL, SG_PLAY_MARKET_APP_URL } from '@order/constants';

export const OrgLinks = {
  sweetgreen: 'https://www.sweetgreen.com/',
  faqs: 'https://faq.sweetgreen.com/',
  contact: 'https://www.sweetgreen.com/contact',
  instagram: 'https://www.instagram.com/sweetgreen/',
  twitter: 'https://twitter.com/sweetgreen',
  tiktok: 'https://www.tiktok.com/@sweetgreen',
  spotify: 'https://open.spotify.com/user/1224421164',
  facebook: 'http://facebook.com/sweetgreen',
  privacy: 'https://www.sweetgreen.com/privacy-policy',
  terms: 'https://www.sweetgreen.com/terms',
  personal: 'http://www.sweetgreen.com/privacy-policy/ca-data-opt-out',
  ios: SG_APP_STORE_APP_URL,
  android: SG_PLAY_MARKET_APP_URL,
};
